var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8167 0.508789H0.442383L29.8167 30.5088V0.508789Z",
    fill: "#00B489"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2959 5.75384C21.9376 5.75384 22.4579 5.19825 22.4579 4.5129C22.4579 3.82755 21.9376 3.27197 21.2959 3.27197C20.6542 3.27197 20.1339 3.82755 20.1339 4.5129C20.1339 5.19825 20.6542 5.75384 21.2959 5.75384ZM20.5212 7.40841C20.0934 7.40841 19.7466 7.77881 19.7466 8.2357C19.7466 8.69261 20.0934 9.06299 20.5212 9.06299V15.6813C20.5212 16.1382 20.8681 16.5086 21.2959 16.5086C21.7238 16.5086 22.0706 16.1382 22.0706 15.6813V8.2357C22.0706 7.77881 21.7238 7.40841 21.2959 7.40841H20.5212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.b43e38a0141a32f65fcff5fad27d58bc.svg";
export { ForwardRef as ReactComponent };